module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "copyt"
  }, [_vm._v("© 2023 Mark Maloy")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher. Printed in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("ISBN-13: 978-1-61121-643-1 (paperback)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN-13: 978-1-61121-644-8 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("epub ISBN 9 781 611 216 448")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("mobi ISBN 9 781 611 216 448")]), _vm._v(" "), _c('p', {
    staticClass: "copy2t"
  }, [_vm._v("Names: Maloy, Mark, author. Title: To the last extremity : the battles for Charleston, 1776-1782 / by Mark Maloy.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Other titles: Battles for Charleston, 1776-1782")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Description: El Dorado Hills, CA : Savas Beatie, [2023] | Series: Emerging Revolutionary War series | Includes bibliographical references. | Summary: “In this book, historian Mark Maloy not only recounts the Revolutionary War history of Charleston, he takes you to the places where the history actually happened. He shows you where the outnumbered Patriots beat back the most powerful navy in the world, where soldiers bravely defended the city in 1779 and 1780, and where thousands suffered under occupation”-- Provided by publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Identifiers: LCCN 2022043897 | ISBN 9781611216431 (paperback) | ISBN 9781611216448 (ebook)")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Subjects: LCSH: Charleston (S.C.)--History--Revolution, 1775-1783--Campaigns. | South Carolina--History--Revolution, 1775-1783--Battlefields--Tours. | Historic sites--South Carolina--Charleston Region--Tours. | Charleston (S.C.)--Tours")]), _vm._v(" "), _c('p', {
    staticClass: "copy2"
  }, [_vm._v("Classification: LCC E241.C4 M25 2022 | DDC 975.7/91503--dc23/ eng/20221104 LC record available at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2022043897",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("https://lccn.loc.gov/2022043897")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_containerc"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Savas Beatie LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("989 Governor Drive, Suite 102")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("El Dorado Hills, California")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("95762 916-941-6896")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("sales@savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.savasbeatie.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Savas Beatie titles are available at special discounts for bulk purchases in the United States by corporations, institutions, and other organizations. For more details, you may e-mail us at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:sales@savasbeatie.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("sales@savasbeatie.com")])])]), _vm._v(", or visit our website at "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.savasbeatie.com")])])]), _vm._v(" for additional information.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04983aad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 66
// module chunks = 0